export default function MaskTelefone(value) {

    let v = value
    //Remove tudo o que não é dígito
    v = v.replace(/\D/g, "")

    //Telefone Fixo
    v = v.substr(0, 10)

    //Coloca um ( no comeco
    v = v.replace(/(\d{0})(\d)/, "$1($2")

    //Coloca um ) entre o 2 e 3 Digito
    v = v.replace(/(\d{2})(\d)/, "$1)$2")

    //Coloca um hífen entre o quarto e o quinto dígitos
    v = v.replace(/(\d{4})(\d{1,4})$/, "$1-$2")

    return v;
}